import { at, sortBy as _sortBy } from 'lodash';

export default function sorting(collection, { sortBy, sortOrder }) {
    if (!sortBy || !sortOrder) {
        return collection;
    }

    const result = _sortBy(collection, (item) => {
        const value = at(item, sortBy)[0];

        if (typeof value === 'string') {
            return value.toLowerCase();
        }

        return value;
    });

    if (sortOrder === 'desc') {
        return result.reverse();
    }

    return result;
};
